import dotPulse from '../elements/dotPulse.js';
dotPulse.register();
